"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLinkHtml = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("../../components/Link/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Function for link action style
 * @function getLinkHtml
 * @param { object }  - returns an object with the appropriate HTML markup for link
 */
const getLinkHtml = data => {
  const {
    /* ActionGroup props */
    action,
    fullyClickableParent,
    isKnockoutLink,
    textForScreenReaders,
    // used when a component is fully clickable. If false will add a tab-index = -1 to avoid duplicate links for ADA
    /* ActionGroupDefault props */
    actionStyle,
    derivedAriaLabel
  } = data;
  const isButtonStyle = actionStyle === 'buttonPrimary' || actionStyle === 'buttonSecondary' || actionStyle === 'buttonTertiary';
  const derivedButtonSize = isButtonStyle ? 'compact' : 'default';
  const hasNegIndex = !textForScreenReaders && fullyClickableParent;
  const updateTabIndex = hasNegIndex ? -1 : undefined;
  const needAriaLabel = !hasNegIndex && !textForScreenReaders && !action?.label;
  const updateAriaLabel = needAriaLabel ? derivedAriaLabel : undefined;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Link.default, _extends({}, action, {
    ariaLabel: updateAriaLabel,
    fullyClickableParent: fullyClickableParent,
    isKnockoutLink: isKnockoutLink,
    screenReaderText: derivedAriaLabel,
    size: derivedButtonSize,
    tabIndex: updateTabIndex,
    variant: actionStyle
  })));
};
exports.getLinkHtml = getLinkHtml;